<div class="resource-overview-page">
  <header class="overview-header">
    <div>
      <h2>Ressourcer</h2>
      <p>Lokationer og lokaler på Y-akse, events på tidslinje på X-akse.</p>
    </div>

    <div class="navigation-controls">
      <button type="button" (click)="goToPreviousPeriod()">Forrige</button>
      <button type="button" (click)="resetToToday()">I dag</button>
      <button type="button" (click)="goToNextPeriod()">Næste</button>
      @if (showDayDatePicker) {
      <label class="day-date-picker">
        <span class="day-date-picker-label">Dato</span>
        <ejs-datepicker
          class="day-date-picker-input"
          [value]="selectedDate"
          locale="da"
          format="dd/MM/yyyy"
          aria-label="Vælg dato"
          (change)="onDayDatePickerChange($event.value)"
          (open)="onDayDatePickerFocus()"
          (close)="onDayDatePickerBlur()"
          (focus)="onDayDatePickerFocus()"
        ></ejs-datepicker>
      </label>
      } @if (!showDayDatePicker) {
      <span class="range-label">{{ currentRangeLabel }}</span>
      }
    </div>
  </header>

  <section class="toolbar">
    <div class="toolbar-left event-type-filters">
      @for (option of eventTypeOptions; track option.value) {
      <label>
        <input
          type="checkbox"
          [(ngModel)]="eventTypeFilters[option.value]"
          (change)="onFilterChanged()"
        />
        {{ option.label }}
      </label>
      }
      <label class="hide-empty-resources">
        <input
          type="checkbox"
          [(ngModel)]="hideResourcesWithoutEvents"
          (ngModelChange)="onFilterChanged()"
        />
        Skjul lokationer og lokaler uden events i perioden
      </label>
      <label class="show-manual-locations">
        <input
          type="checkbox"
          [(ngModel)]="showManualLocations"
          (ngModelChange)="onFilterChanged()"
        />
        Vis manuelle lokationer fra events i perioden
      </label>
      @if (showNightHoursFilter) {
      <label class="hide-night-hours">
        <input
          type="checkbox"
          [(ngModel)]="hideNightHoursInDayView"
          (ngModelChange)="onNightHoursFilterChanged()"
        />
        Skjul nattetimer (18:00–08:00)
      </label>
      }
    </div>

    <div class="toolbar-right toolbar-settings-toggle">
      <button type="button" (click)="toggleSettings()">
        {{
          showSettings
            ? "Skjul visningsindstillinger"
            : "Vis visningsindstillinger"
        }}
      </button>
    </div>
  </section>

  @if (showSettings) {
  <section class="settings-panel">
    <div class="settings-panel-header">
      <div class="settings-display-option">
        <label>
          <input
            type="checkbox"
            [(ngModel)]="showLocationRows"
            (ngModelChange)="onFilterChanged()"
          />
          Vis lokationer som egne rækker
        </label>
        <span class="settings-display-option-hint">
          Når slået fra vises kun lokalerne, hvis lokationen har lokaler.
          Lokationer uden lokaler vises stadig.
        </span>
      </div>
      <button type="button" (click)="applyOrgDefaults()">
        Brug org defaults
      </button>
    </div>
    <div class="settings-column">
      <h3>Lokationer</h3>
      @for (location of allLocations; track trackByGuid($index, location)) {
      <label>
        <input
          type="checkbox"
          [checked]="isLocationVisible(location.guid)"
          (change)="toggleLocationVisibility(location.guid)"
        />
        {{ location.locations_name }}
      </label>
      }
    </div>
    <div class="settings-column">
      <h3>Lokaler</h3>
      @for (location of allLocations; track trackByGuid($index, location)) {
      <div class="location-room-group">
        <div class="location-title">{{ location.locations_name }}</div>
        @for (room of getLocationRooms(location.guid); track trackByGuid($index,
        room)) {
        <label>
          <input
            type="checkbox"
            [disabled]="!isLocationVisible(location.guid)"
            [checked]="isRoomVisible(room.guid)"
            (change)="toggleRoomVisibility(room.guid)"
          />
          {{ room.room_name }}
        </label>
        }
      </div>
      }
    </div>
    @if (allOrgResources.length > 0) {
    <div class="settings-column">
      <h3>Ressourcer</h3>
      @for (resource of allOrgResources; track trackByOrgResourceId($index,
      resource)) {
      <label>
        <input
          type="checkbox"
          [checked]="isOrgResourceVisible(resource.id)"
          (change)="toggleOrgResourceVisibility(resource.id)"
        />
        {{ resource.label }}@if (resource.is_active === false) {
        <span class="inactive-resource-label"> (inaktiv)</span>
        }
      </label>
      }
    </div>
    }
  </section>
  }

  <section class="content-area">
    @if (!isLoading && errorMessage) {
    <section class="state-message error">{{ errorMessage }}</section>
    } @if (!isLoading && !errorMessage && resourceDataSource.length === 0) {
    <section class="state-message">
      @if (hideResourcesWithoutEvents) { Ingen lokationer, lokaler eller
      ressourcer med events i perioden ud fra valgte typer og filtre. } @else {
      Ingen events matcher valgt periode og filtre. }
    </section>
    } @if (!errorMessage && resourceDataSource.length > 0) {
    <section class="schedule-wrapper" (click)="onScheduleWrapperClick($event)">
      <ejs-schedule
        #scheduleObj
        height="auto"
        cssClass="duna-resource-schedule"
        [class.can-add-events]="canAddEventsCached"
        [selectedDate]="selectedDate"
        [firstDayOfWeek]="1"
        locale="da"
        [views]="scheduleViews"
        [currentView]="currentView"
        [eventSettings]="eventSettings"
        [timeScale]="timeScale"
        [startHour]="scheduleStartHour"
        [endHour]="scheduleEndHour"
        [workHours]="dayWorkHours"
        [rowAutoHeight]="true"
        [readonly]="true"
        [group]="scheduleGroup"
        [resources]="scheduleResources"
        [showQuickInfo]="false"
        (eventClick)="onEventClick($event)"
        (cellClick)="onCellClick($event)"
        (popupOpen)="onPopupOpen($event)"
        (eventRendered)="onEventRendered($event)"
        (navigated)="onScheduleNavigated()"
        (actionComplete)="onScheduleActionComplete($event)"
        (dataBound)="onScheduleDataBound()"
        (renderCell)="onRenderCell($event)"
      >
      </ejs-schedule>
    </section>
    } @if (isLoading) {
    <div
      class="loading-overlay"
      role="status"
      aria-live="polite"
      aria-label="Opdaterer ressourceoversigt"
    >
      <div class="loading-spinner" aria-hidden="true"></div>
      <span>Opdaterer...</span>
    </div>
    }
  </section>
</div>
